import { inject, ref, watch } from 'vue';

import { defineAppPlugin } from '@/main';

import type { Ref } from 'vue';

interface UseCookieOptions<T> {
  default?: () => T;
}

const CACHE_KEY = Symbol();

export default defineAppPlugin(({ app }) => {
  const cache = new Map<string, any>();
  app.provide(CACHE_KEY, cache);
});

export function useCache<T>(key: string, options: UseCookieOptions<T>): Ref<T> {
  const cache = inject<Map<string, any>>(CACHE_KEY)!;

  const value = ref((cache.get(key) as T) ?? options.default?.());
  const callback = () => {
    cache.set(key, value.value);
  };

  watch(value, callback, { deep: true });

  return value as Ref<T>;
}
